import React from "react";
import "./NormalForms.css"

class NormalForms extends React.Component {
    constructor(props) {
        /* We MUST call the parent class contructor and send it the props object */
        super(props);

        // Setting the initial state of the NormalForms component
        this.state =
            {
                contents: this.props.value
            };

        this.introPosition = 42;
        this.firstPosition = 338;
        this.secondPosition = 1149;
        this.thirdPosition = 1846;
        this.bottPosition = 2252;
        this.lastFrameTop = 2309;
        this.debug = false;

        /*
           ----------------------------------------- Top -----------------------------------------
           |                                                                                     |
           | |*********************************************************************************| |
           | |                                     Buttons                                     | |
           | |*********************************************************************************| |
           | |                                                                                 | |
           | |************************************ Container **********************************| |
           | |                                                                                 | |
           | | |*****************************************************************************| | |
           | | |                                    Intro                                    | | |
           | | |*****************************************************************************| | |
           | |                                                                                 | |   
           | | |*****************************************************************************| | |
           | | |                                    First                                    | | |
           | | |*****************************************************************************| | |
           | |                                                                                 | |   
           | | |*****************************************************************************| | |
           | | |                                    Second                                   | | |
           | | |*****************************************************************************| | |
           | |                                                                                 | |   
           | | |*****************************************************************************| | |
           | | |                                    Third                                    | | |
           | | |*****************************************************************************| | |
           | |                                                                                 | |   
           | |********************************** End of Container *****************************| |
           |                                                                                     |
           |************************************* End of Top ************************************|
    
        */

    } // End of constructor()



    onTopClick = () => {

        if (this.debug === true) {
            console.log("im in onTopClick");
            //this.top.scrollIntoView();
            console.log("\n\n-------------------------------------------------\n");
            console.log("this.container.scrollTop is " + this.container.scrollTop);
            console.log("");
            console.log("this.tippyTop.scrollHeight is " + this.tippyTop.scrollHeight);
            console.log("this.tippyTop.getBoundingClientRect().top is " + this.tippyTop.getBoundingClientRect().top);
            console.log("this.tippyTop.getBoundingClientRect().bottom is " + this.tippyTop.getBoundingClientRect().bottom);
            console.log("");

            console.log("this.buttons.scrollTop is " + this.buttons.scrollTop);
            console.log("this.buttons.scrollHeight is " + this.buttons.scrollHeight);
            console.log("this.buttons.getBoundingClientRect().top is " + this.buttons.getBoundingClientRect().top);
            console.log("this.buttons.getBoundingClientRect().bottom is " + this.buttons.getBoundingClientRect().bottom);
            console.log("");

            console.log("this.container.scrollTop is " + this.container.scrollTop);
            console.log("this.container.scrollHeight is " + this.container.scrollHeight);
            console.log("this.container.getBoundingClientRect().top is " + this.container.getBoundingClientRect().top);
            console.log("this.container.getBoundingClientRect().bottom is " + this.container.getBoundingClientRect().bottom);
            console.log("");

            console.log("this.intro.scrollTop is " + this.intro.scrollTop);
            console.log("this.intro.scrollHeight is " + this.intro.scrollHeight);
            console.log("this.intro.getBoundingClientRect().top is " + this.intro.getBoundingClientRect().top);
            console.log("this.intro.getBoundingClientRect().bottom is " + this.intro.getBoundingClientRect().bottom);
            console.log("");

            console.log("this.first.scrollTop is " + this.first.scrollTop);
            console.log("this.first.scrollHeight is " + this.first.scrollHeight);
            console.log("this.first.getBoundingClientRect().top is " + this.first.getBoundingClientRect().top);
            console.log("this.first.getBoundingClientRect().bottom is " + this.first.getBoundingClientRect().bottom);
            console.log("");

            console.log("this.second.scrollTop is " + this.second.scrollTop);
            console.log("this.second.scrollHeight is " + this.second.scrollHeight);
            console.log("this.second.getBoundingClientRect().top is " + this.second.getBoundingClientRect().top);
            console.log("this.second.getBoundingClientRect().bottom is " + this.second.getBoundingClientRect().bottom);
            console.log("");

            console.log("this.third.scrollTop is " + this.third.scrollTop);
            console.log("this.third.scrollHeight is " + this.third.scrollHeight);
            console.log("this.third.getBoundingClientRect().top is " + this.third.getBoundingClientRect().top);
            console.log("this.third.getBoundingClientRect().bottom is " + this.third.getBoundingClientRect().bottom);
            console.log("");
        }
        console.log("this.tippyTop is ");
        console.log(this.tippyTop);
        this.tippyTop.scrollIntoView(true);

    }

    onBottomClick = () => {
        console.log("I'm in onBottomClick");
        this.bott.scrollIntoView();

    }

    onUpClick = () => {

        let currentTop = this.container.scrollTop;

        if (this.debug === true) {
            console.log("\nIm in onUpClick");
            console.log("currentTop is " + currentTop);
            console.log("this.introPosition is " + this.introPosition);
            console.log("this.firstPosition is " + this.firstPosition);
            console.log("this.secondPosition is " + this.secondPosition);
            console.log("this.thirdPosition is " + this.thirdPosition);
            console.log("this.lastFrameTop is " + this.lastFrameTop);
            console.log("this.bottPosition is " + this.bottPosition);
        }

        if (currentTop > this.bottPosition) 
        {
            if(this.debug === true)
            {
                console.log("Scroll bott into view.");
            }
            this.bott.scrollIntoView();
        }

        if( (currentTop > this.thirdPosition) && (currentTop <= this.lastFrameTop))
        {
            if(this.debug === true)
            {
                console.log("Scroll third into view.");
            }
            this.third.scrollIntoView();
        }

        else if ((currentTop > this.secondPosition) && (currentTop <= this.thirdPosition)) 
        {
            if(this.debug === true)
            {
                console.log("Scroll second into view.");
            }

            this.second.scrollIntoView();
        }

        else if ((currentTop > this.firstPosition) && (currentTop <= this.secondPosition)) 
        {
            if(this.debug === true)
            {
                console.log("Scroll first into view.");
            }

            this.first.scrollIntoView();
        }

        else if ((currentTop > this.introPosition) && (currentTop <= this.firstPosition)) 
        {
            if(this.debug === true)
            {
                console.log("Scroll intro into view.");
            }

            this.intro.scrollIntoView();
        }

        else if ((currentTop > 0) && (currentTop <= this.introPosition)) 
        {
            if(this.debug === true)
            {
                console.log("Scroll tippyTop into view.");
            }

            this.tippyTop.scrollIntoView();
        }
    }



    onDownClick = () => {
        let currentTop = this.container.scrollTop;

        if (this.debug === true) {
            console.log("\nIm in onDownClick");
            console.log("currentTop is " + currentTop);
            console.log("this.introPosition is " + this.introPosition);
            console.log("this.firstPosition is " + this.firstPosition);
            console.log("this.secondPosition is " + this.secondPosition);
            console.log("this.thirdPosition is " + this.thirdPosition);
            console.log("this.bottPosition is " + this.bottPosition);
        }

        if (currentTop < this.introPosition) {

            if(this.debug === true)
            {
                console.log("Scroll intro into view.");
            }

            this.intro.scrollIntoView();
        }

        else if ((currentTop >= this.introPosition) && (currentTop < this.firstPosition)) {
            
            if(this.debug === true)
            {
                console.log("Scroll first into view.");
            }

            this.first.scrollIntoView();
        }

        else if ((currentTop >= this.firstPosition) && (currentTop < this.secondPosition)) {
            
            if(this.debug === true)
            {
                console.log("Scroll second into view.");
            }

            this.second.scrollIntoView();
        }

        else if ((currentTop >= this.secondPosition) && (currentTop < this.thirdPosition)) {
            
            if(this.debug === true)
            {
                console.log("Scroll third into view.");
            }
            
            this.third.scrollIntoView();
        }

        else if ((currentTop >= this.thirdPosition) && (currentTop < this.bottPosition)) {

            if(this.debug === true)
            {
                console.log("Scroll bott into view.");
            }

            this.bott.scrollIntoView();
        }

    } // End of onUpClick()


    firstClick = (event) => {
        console.log("First was clicked.");
        this.first.scrollIntoView();
    }

    secondClick = (event) => {
        console.log("Second was clicked.");
        this.second.scrollIntoView();
    }

    thirdClick = (event) => {
        console.log("Third was clicked.");
        this.third.scrollIntoView();
    }

    render() {
        return (

            <div className='NormalFormsMain scroll-div'>

            <div className="Shit">
                <button className="shitbtn" onClick={this.onTopClick}>Top</button>
                <button className="shitbtn" onClick={this.firstClick}>First Normal Form</button>
                <button className="shitbtn" onClick={this.secondClick}>Second Normal Form</button>
                <button className="shitbtn" onClick={this.thirdClick}>Third Normal Form</button>
            </div>

                <div ref={node => this.buttons = node} className="VerticalButtons scroll-div">
                    <button onClick={this.onTopClick}>&#x021D1;</button>
                    <button onClick={this.onUpClick}>&#x2191;</button>
                    <button onClick={this.onDownClick}>&#x2193;</button>
                    <button onClick={this.onBottomClick} >&#x21d3;</button>
                </div>

                <div ref={node => this.container = node} className="NormalFormsFollowing scroll-div">
                    <h3 ref={node => this.tippyTop = node}>Normal Forms</h3>

                    {/*  *******************Intro Div ***************************/}
                    <div className="scroll-div" ref={node => this.intro = node}>
                        
                        <p>This is a cache of information about database design that I want to
                            have at hand.  This information can be found in books and around the
                            internet, but I want it collected in one place and easily understood
                            by me.
                        </p>

                        <p>The rules I'm going to talk about here are rules that were formulated by
                       Edgar Frank Codd.  Ted Codd woked for IBM and published the rules for
                       database table normalization that are discussed here in the 1970s.  He
                       is considered the father of relational databases.  He passed away in 2003
                       according to <a href={"https://en.wikipedia.org/wiki/Edgar_F._Codd"}
                                target={"_blank"}>Wikipedia</a> </p>

                        <p>There are more than three normal forms, but having tables that meet the
                           requirements for
                        the <span className="text-click" onClick={this.firstClick}>first</span>,
                        <span className="text-click" onClick={this.secondClick}> second</span>, and
                        <span className="text-click" onClick={this.thirdClick}> third</span> normal
                        forms will result in at least a decent database design.</p>

                    </div>



                    {/*  *******************First Div ***************************/}
                    <div className="scroll-div" ref={node => this.first = node}>
                        <h5 >First Normal Form</h5>
                        <p>For a table to be in first normal form, the rows of the table must have
                            unique identification.  This allows us to search the table and find
                            a specific row in the table.  Note that the identification does not have
                            to be only one column.  This unique row identification is called the
                            table's primary key.   We will identify the primary key
                    by its <span className="primary-key">red font color.</span></p>

                        <p>Each column in the table must have "atomic" data.  That means a single
                            piece of information.  An example of a column's content that is not
                        an atomic piece of data is shown in the following table:</p>


                        <div className="table-responsive">
                            <table className="table table-striped table-hover table-condensed">
                                <thead>
                                    <tr>
                                        <th className="primary-key">Name </th>

                                        <th>Phone</th>
                                    </tr>
                                </thead>
                            </table>
                            <div className="bodycontainer scrollable">
                                <table className="table table-hover table-striped table-sm table-scrollable" id="ei-item-table">
                                    <tbody>
                                        <tr>
                                            <td className="wi_d text-center primary-key">Joe</td>

                                            <td className="wi_d text-center">976-555-7399, 976-555-9324</td>


                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>

                        <p>Another requirement for first normal form is that there are no
                            "lists" built into the column definitions.  You can't create
                            a table like the one that follows to get around the requirement
                        that each column contains atomic data:</p>

                        <div className="table-responsive">
                            <table className="table table-striped table-hover table-condensed">
                                <thead>
                                    <tr>
                                        <th className="primary-key">Name </th>

                                        <th>Phone One</th>

                                        <th>Phone Two</th>
                                    </tr>
                                </thead>
                            </table>
                            <div className="bodycontainer scrollable">
                                <table className="table table-hover table-striped table-sm table-scrollable" id="ei-item-table">
                                    <tbody>
                                        <tr>
                                            <td className="wi_d text-center primary-key">Joe</td>

                                            <td className="wi_d text-center">976-555-7399</td>

                                            <td className="wi_d text-center">976-555-9324</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>

                        <p>So, what should the table be?</p>

                        <div className="table-responsive">
                            <table className="table table-striped table-hover table-condensed">
                                <thead>
                                    <tr>
                                        <th className="primary-key">Number</th>

                                        <th className="text-center">Name</th>


                                    </tr>
                                </thead>
                            </table>
                            <div className="bodycontainer scrollable">
                                <table className="table table-hover table-striped table-sm table-scrollable" id="ei-item-table">
                                    <tbody>
                                        <tr>
                                            <td className="wi_d text-left primary-key">976-555-7399</td>
                                            <td className="wi_d text-left">Joe</td>
                                        </tr>

                                        <tr>

                                            <td className="wi_d text-left primary-key">976-555-9324</td>
                                            <td className="wi_d text-left">Joe</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                        <p>In my opinion, the rules for the first normal form just provide enough structure so
                            that other important normalization rules can be created.</p>
                    </div>


                    {/*  *******************Second Div ***************************/}
                    <div className="scroll-div" ref={node => this.second = node}>
                        <h5>Second Normal Form</h5>
                        <p>For a table to be in second normal form, every item in a row must contain
                        information about the ENTIRE primary key.  Consider the following table containing
                        information about students and their course grades:</p>

                        <div className="table-responsive">
                            <table className="table table-striped table-hover table-condensed">
                                <thead>
                                    <tr>
                                        <th className="primary-key">Name</th>

                                        <th className="primary-key">Class ID</th>

                                        <th>Instructor</th>

                                        <th>Grade</th>
                                    </tr>
                                </thead>
                            </table>
                            <div className="bodycontainer scrollable">
                                <table className="table table-hover table-striped table-sm table-scrollable" id="ei-item-table">
                                    <tbody>
                                        <tr>
                                            <td className="wi_d text-center primary-key">Bill</td>

                                            <td className="wi_d text-center primary-key">455</td>

                                            <td className="wi_d text-center">Dr Kildare</td>

                                            <td className="wi_d text-center">B+</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>

                        <p>This table has a composite primary key composed of the combination of name and class ID.
                            The grade attribute does contain information about the entity defined by the combination
                            of name and course Id.  It is the grade that bill received in that class.  However, the
                            instructor is information about the class ID only.  This table can be split into two
                            separate tables each being in second normal form:
                        </p>

                        <div className="table-responsive">
                            <table className="table table-striped table-hover table-condensed">
                                <thead>
                                    <tr>
                                        <th className="primary-key">Name</th>

                                        <th className="primary-key">Class ID</th>

                                        <th>Grade</th>
                                    </tr>
                                </thead>
                            </table>
                            <div className="bodycontainer scrollable">
                                <table className="table table-hover table-striped table-sm table-scrollable" id="ei-item-table">
                                    <tbody>
                                        <tr>
                                            <td className="wi_d text-center primary-key">Bill</td>

                                            <td className="wi_d text-center primary-key">455</td>

                                            <td className="wi_d text-center">B+</td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-striped table-hover table-condensed">
                                <thead>
                                    <tr>
                                        <th className="primary-key">Class ID</th>

                                        <th>Instructor</th>

                                    </tr>
                                </thead>
                            </table>
                            <div className="bodycontainer scrollable">
                                <table className="table table-hover table-striped table-sm table-scrollable" id="ei-item-table">
                                    <tbody>

                                        <tr>
                                            <td className="wi_d text-center primary-key">455</td>

                                            <td className="wi_d text-center">Dr Kildare</td>
                                        </tr>

                                    </tbody>
                                </table>

                            </div>
                        </div>
                        <p>Tables that do not meet the requirements for the second normal form cause data redundancy.  The
                            information that Dr Kildare teaches class 455 occurs over and over again within the rows of the
                            table that is not in second normal form.</p>
                    </div>


                    {/*  *******************Third Div ***************************/}
                    <div className="scroll-div" ref={node => this.third = node}>
                        <h5>Third Normal Form</h5>
                        <p>For a table to be in third normal form, it must first be in second normal form.
                            Additionally, there can be no dependencies amongst the column entries other than
                        the primary key.  Consider the following table:</p>

                        <div className="table-responsive">
                            <table className="table table-striped table-hover table-condensed">
                                <thead>
                                    <tr>
                                        <th className="primary-key">Name </th>

                                        <th>Car Make</th>

                                        <th>Car Model</th>
                                    </tr>
                                </thead>
                            </table>
                            <div className="bodycontainer scrollable">
                                <table className="table table-hover table-striped table-sm table-scrollable" id="ei-item-table">
                                    <tbody>
                                        <tr>
                                            <td className="wi_d text-center primary-key">Sam</td>

                                            <td className="wi_d text-center">Impala</td>

                                            <td className="wi_d text-center">Chevrolet</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>

                        </div>

                        <p>This can be corrected.  Consider:</p>

                        <div className="table-responsive">
                            <table className="table table-striped table-hover table-condensed">
                                <thead>
                                    <tr>
                                        <th className="primary-key">Name </th>

                                        <th>Car Model</th>

                                    </tr>
                                </thead>
                            </table>
                            <div className="bodycontainer scrollable">
                                <table className="table table-hover table-striped table-sm table-scrollable" id="ei-item-table">
                                    <tbody>
                                        <tr>
                                            <td className="wi_d text-center primary-key">Sam</td>

                                            <td className="wi_d text-center">Impala</td>


                                        </tr>

                                    </tbody>
                                </table>
                            </div>

                        </div>

                        <div className="table-responsive">
                            <table className="table table-striped table-hover table-condensed">
                                <thead>
                                    <tr>
                                        <th className="primary-key">Car Model </th>

                                        <th>Car Make</th>


                                    </tr>
                                </thead>
                            </table>
                            <div className="bodycontainer scrollable">
                                <table className="table table-hover table-striped table-sm table-scrollable" id="ei-item-table">
                                    <tbody>
                                        <tr>
                                            <td className="wi_d text-center primary-key">Impala</td>

                                            <td className="wi_d text-center">Chevrolet</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <p ref={node => this.bott = node}>The first normal form says that there should be
                a primary key in every table.  The second normal form says that every item in a row
                should give information about the entire primary key and not just a part of it.  The
                third normal form says that each item should ONLY give information about the primary key
                and not about other items in the row.  The father of relational databases was E.F. Codd. </p>

                    <p>In summary, each item in a row should give information about the key, the whole key,
                    and nothing but the key, so help you Codd.</p>

                </div>

            </div>

        )

    }

}

export default NormalForms;



// WEBPACK FOOTER //
// ./src/components/WebLog/NormalForms.js